module.exports = __webpack_public_path__ + "img/baner3_large.c58050cc.webp";